import { Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Papa } from "ngx-papaparse";

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  private constructor(
    private papa: Papa,
    public acRoute: ActivatedRoute
  ) {}
  public static somenteNumeros(str: string): string {
    if (str) {
      return str.toString().replace(/[^0-9]+/g, '');
    } else {
      return '';
    }
  }

  public static emailValid(email: string): boolean {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  public static dateBeforeNow(date: Date) {
    return date < new Date();
  }
  public static dateAfterNow(date: Date) {
    return date > new Date();
  }
  public static dateAfter(
    date: Date,
    dateAfter: Date = new Date('1900-01-01')
  ) {
    return date > dateAfter;
  }
  public static dateAfterThisYear(
    date: Date,
    dateAfter: Date = new Date('2022-01-01')
  ) {
    return date > dateAfter;
  }
  public static dateBefore(date: Date, dateBefore: Date) {
    return date < dateBefore;
  }

  public static dateAfterYears(date: Date, qtYears: number = 5) {
    const now = new Date();
    const maxDate = new Date(
      `${now.getFullYear() + qtYears}-${now.getMonth}-${now.getDay()}`
    );
    return date <= maxDate;
  }

  public static validaCPF(cpf: string): boolean {
    let Soma = 0;
    // Verifica se a variável cpf é igual a "undefined", exibindo uma msg de erro
    if (cpf === undefined || cpf === null || cpf == '') {
      return false;
    }

    // Esta função retira os caracteres . e - da string do cpf, deixando apenas os números
    let strCPF = cpf.replace('.', '').replace('.', '').replace('-', '');
    // Testa as sequencias que possuem todos os dígitos iguais e, se o cpf não tem 11 dígitos, retorna falso e exibe uma msg de erro
    if (
      strCPF === '00000000000' ||
      strCPF === '11111111111' ||
      strCPF === '22222222222' ||
      strCPF === '33333333333' ||
      strCPF === '44444444444' ||
      strCPF === '55555555555' ||
      strCPF === '66666666666' ||
      strCPF === '77777777777' ||
      strCPF === '88888888888' ||
      strCPF === '99999999999' ||
      strCPF.length !== 11
    ) {
      return false;
    }

    // Os seis blocos seguintes de funções vão realizar a validação do CPF propriamente dito, conferindo se o DV bate. Caso alguma das funções não consiga verificar
    // o DV corretamente, mostrará uma mensagem de erro ao usuário e retornará falso, para que o usário posso digitar novamente um número para ser testado

    //Multiplica cada digito por numeros de 1 a 9, soma-os e multiplica-os por 10. Depois, divide o resultado encontrado por 11 para encontrar o resto
    for (let i = 1; i <= 9; i++) {
      Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    }

    let Resto = (Soma * 10) % 11;
    if (Resto === 10 || Resto === 11) {
      Resto = 0;
    }

    if (Resto !== parseInt(strCPF.substring(9, 10))) {
      return false;
    }

    Soma = 0;
    for (let k = 1; k <= 10; k++) {
      Soma = Soma + parseInt(strCPF.substring(k - 1, k)) * (12 - k);
    }

    Resto = (Soma * 10) % 11;
    if (Resto === 10 || Resto === 11) {
      Resto = 0;
    }

    if (Resto !== parseInt(strCPF.substring(10, 11))) {
      return false;
    } else {
      return true;
    }
  }

  exportToCSV(data: any[], filename = 'export.csv') {
        const csv = this.papa.unparse(data, {
            delimiter: ';',
            quotes: true,
            quoteChar: '"',
            escapeChar: '"' 
        });
        const bom = '\uFEFF';
        const csvWithBom = bom + csv;
        const blob = new Blob([csvWithBom], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    checkQueryParams(key: string): boolean {
        const params = this.acRoute.snapshot.queryParams;
        return params && params[key] !== undefined;
    }

}

